<script setup lang="ts">
const props = defineProps<{
  review?: Review
  isReviewPage?: boolean
}>()

const photoDialog = ref()
const photoDialogSource = ref()

function openPhoto(photo: any) {
  photoDialogSource.value = photo
  photoDialog.value.open()
}

const isTrustpilot = computed(() => props.review?.source === 'Trustpilot')
</script>

<template>
  <ion-card class="os-review-card">
    <os-row cross-axis-alignment="stretch" gap="none">
      <os-expanded>
        <os-column
          cross-axis-alignment="stretch"
          gap="narrow"
          class="os-review-card__details"
        >
          <os-row main-axis-alignment="space-between">
            <h2 class="os-review-card__name">{{ review?.name }}</h2>
            <small>
              <os-date :value="review?.scoreDate" />
            </small>
          </os-row>

          <os-row
            main-axis-alignment="space-between"
            cross-axis-alignment="center"
            class="os-review-card__details__meta"
          >
            <small v-if="review?.translation">{{
              $t('label.automatically_translated')
            }}</small>
            <ion-button
              v-if="isTrustpilot"
              size="small"
              fill="clear"
              :href="`https://${$t('language.code') === 'EN' ? '' : $t('language.code') + '.'}legal.trustpilot.com/for-reviewers/guidelines-for-reviewers`"
              target="blank"
            >
              {{ $t('label.review_source', { source: review?.source }) }}
              <ion-icon
                slot="end"
                :icon="ioniconsInformationCircleOutline"
              ></ion-icon>
            </ion-button>
          </os-row>

          <p
            v-if="review?.translation"
            v-html="review?.translation.translation"
          />
          <p v-else v-html="review?.review" />

          <os-row v-if="!props.isReviewPage" main-axis-alignment="start" wrap>
            <img
              v-for="photo in review?.photo ?? []"
              :key="photo.id"
              :src="`https://assets.outspot.be/review_photos/${photo.reviewId}/${photo.fileName}`"
              class="os-review-card__photo_small"
              @click="openPhoto(photo)"
            />
          </os-row>

          <os-row v-if="props.isReviewPage" main-axis-alignment="start" wrap>
            <img
              v-for="photo in review?.photo ?? []"
              :key="photo.id"
              :src="`https://assets.outspot.be/review_photos/${photo.reviewId}/${photo.fileName}`"
              class="os-review-card__photo"
              @click="openPhoto(photo)"
            />
          </os-row>
        </os-column>
      </os-expanded>
    </os-row>

    <os-dialog ref="photoDialog" size="large" padding="none">
      <img
        :src="`https://assets.outspot.be/review_photos/${photoDialogSource.reviewId}/${photoDialogSource.fileName}`"
        class="os-review-card__photo-dialog__photo"
      />
    </os-dialog>
  </ion-card>
</template>

<style scoped>
.os-review-card {
  background-color: var(--background--primary);
}

.os-review-card__details {
  padding: 1rem;
}

.os-review-card__name {
  text-transform: capitalize;
}

.os-review-card__photo {
  width: 10rem;
  height: 10rem;
  margin-top: 0.25rem;
  object-fit: cover;
  border: solid 2px var(--white);
  border-radius: 0.25rem;
  cursor: pointer;
}

.os-review-card__photo_small {
  width: 5rem;
  height: 5rem;
  margin-top: 0.25rem;
  object-fit: cover;
  border: solid 2px var(--white);
  border-radius: 0.25rem;
  cursor: pointer;
}

.os-review-card__photo-dialog__photo {
  width: 100%;
  object-fit: contain;
  border: none;
  width: 100%;
  height: calc(100vh - max(30px, var(--ion-safe-area-top)) - 67px);
  margin-bottom: -1rem;
}

.os-review-card__details__meta {
  opacity: 0.5;
}

.os-review-card__details__meta ion-button {
  font-weight: normal;
  min-height: 0;
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-end: 2px;
  font-size: 0.75rem;
}

@media only screen and (min-width: 768px) and (min-height: 600px) {
  .os-review-card__photo-dialog__photo {
    width: 850px !important;
    height: 576px !important;
  }
}

@media only screen and (min-width: 1024px) and (min-height: 768px) {
  .os-review-card__photo-dialog__photo {
    width: 1024px !important;
    height: 693px !important;
  }
}

@media only screen and (min-width: 1264px) and (min-height: 1024px) {
  .os-review-card__photo-dialog__photo {
    width: 1270px !important;
    height: 860px !important;
  }
}
</style>
